import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Upload } from 'lucide-react';
import { submitEmployerRequirement } from '../services/api';
import toast from 'react-hot-toast';

export default function EmployerRequirements() {
  const [form, setForm] = useState({
    enquiry_for: '', name: '', company_name: '', country: 'India',
    current_city: '', current_locality: '', city: '', email: '', phone: '', requirement: ''
  });
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const fileRef = useRef();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.enquiry_for || !form.name || !form.company_name || !form.email || !form.phone || !form.requirement) {
      toast.error('Please fill all required fields');
      return;
    }
    setSubmitting(true);
    const data = new FormData();
    Object.entries(form).forEach(([k, v]) => data.append(k, v));
    if (file) data.append('document', file);
    try {
      await submitEmployerRequirement(data);
      toast.success('Requirement submitted successfully!');
      setForm({ enquiry_for: '', name: '', company_name: '', country: 'India', current_city: '', current_locality: '', city: '', email: '', phone: '', requirement: '' });
      setFile(null);
    } catch {
      toast.error('Failed to submit requirement');
    }
    setSubmitting(false);
  };

  return (
    <>
      <div className="page-header">
        <h1>Employers Requirements</h1>
        <p>Tell us your hiring needs and we'll find the right talent for you</p>
        <div className="breadcrumb">
          <Link to="/">Home</Link> / <span>Employers Requirements</span>
        </div>
      </div>
      <div className="form-page">
        <div className="form-card">
          <h2>Submit Your Requirement</h2>
          <p className="subtitle">Fill in the details below and our team will get back to you with the best candidates.</p>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Enquiry For *</label>
              <select value={form.enquiry_for} onChange={(e) => setForm({...form, enquiry_for: e.target.value})} required>
                <option value="">-- Select --</option>
                <option value="Looking For Job/Job Search">Looking For Job / Job Search</option>
                <option value="Hire Staff/Job Post">Hire Staff / Job Post</option>
              </select>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Your Name *</label>
                <input type="text" value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Company Name *</label>
                <input type="text" value={form.company_name} onChange={(e) => setForm({...form, company_name: e.target.value})} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Select Country *</label>
                <select value={form.country} onChange={(e) => setForm({...form, country: e.target.value})} required>
                  <option value="India">India</option>
                  <option value="United States">United States</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="Canada">Canada</option>
                  <option value="Australia">Australia</option>
                  <option value="UAE">UAE</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Germany">Germany</option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Bahrain">Bahrain</option>
                  <option value="Oman">Oman</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="South Africa">South Africa</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                </select>
              </div>
              <div className="form-group">
                <label>Current City *</label>
                <input type="text" value={form.current_city} onChange={(e) => setForm({...form, current_city: e.target.value})} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Current Locality</label>
                <input type="text" value={form.current_locality} onChange={(e) => setForm({...form, current_locality: e.target.value})} />
              </div>
              <div className="form-group">
                <label>City *</label>
                <input type="text" value={form.city} onChange={(e) => setForm({...form, city: e.target.value})} required />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>E-mail *</label>
                <input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>Phone / Mobile *</label>
                <input type="tel" value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} required />
              </div>
            </div>
            <div className="form-group">
              <label>Your Requirement *</label>
              <textarea value={form.requirement} onChange={(e) => setForm({...form, requirement: e.target.value})}
                placeholder="Describe your hiring needs, positions required, number of vacancies, etc." required />
            </div>
            <div className="form-group">
              <label>Upload Document (Optional)</label>
              <div className="file-upload" onClick={() => fileRef.current.click()}>
                <Upload size={36} color="#94a3b8" />
                <p>Click to upload (PDF, DOC, DOCX, RTF — Max 2MB)</p>
                {file && <div className="file-name">{file.name}</div>}
                <input type="file" ref={fileRef} accept=".pdf,.doc,.docx,.rtf"
                  onChange={(e) => setFile(e.target.files[0])} />
              </div>
            </div>
            <button type="submit" className="btn-submit" disabled={submitting}>
              {submitting ? 'Submitting...' : 'Submit Requirement'}
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
